import React, { useEffect, useState } from 'react'
import { useMediaQuery } from '@material-ui/core'

import styles from './index.module.scss'

import { ContentType } from '../../types/trialLessons'
import { THRESHOLD_DESKTOP_WIDTH } from '../../utils/constants'
import { AwardContentSection } from '../AwardContentSection'
import CmSectionMovie from '../CmSectionMovie'
import { useRouter } from 'next/router'

type Props = {
  contentType: ContentType
  location?: string
}

const RESKILLING_SOURCES: string[] = ['deca', 'lks']

export const AwardContent = ({ contentType, location }: Props) => {
  const [showReskilling, setShowReskilling] = useState<boolean>(false)

  const router = useRouter()
  const isPc = useMediaQuery(`(min-width:${THRESHOLD_DESKTOP_WIDTH}px)`)
  const isLocation =
    location && ['she_ginza', 'she_umeda', 'she_nagoya'].includes(location)

  // NOTE: RESKILLING_SOURCESでの出し分けは2024年末時点では行わない方針となったが、
  //       CRMチームとの合意が取れていないため、コード上は残しておく
  useEffect(() => {
    if (router?.isReady) {
      const utm_source = router.query.utm_source
      if (RESKILLING_SOURCES.some(s => s === utm_source)) {
        setShowReskilling(true)
      }
    }
  }, [router])

  return (
    <>
      {!isLocation && <CmSectionMovie />}
      <section id="award-content" className={styles.container}>
        <AwardContentSection isPc={isPc} />
      </section>
    </>
  )
}
